import { render, staticRenderFns } from "./ImportProductsModal.vue?vue&type=template&id=f55302a4&"
import script from "./ImportProductsModal.vue?vue&type=script&lang=js&"
export * from "./ImportProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports